import { FC } from 'react';
import imgEmpty from 'assets/images/empty.png';

import styles from './styles.module.scss';

export const EmptyBlank: FC = () => {
  return (
    <div className={styles['empty-blank']}>
      <img src={imgEmpty} alt="empty" className={styles['empty-blank__img']} />
      <h1 className={styles['empty-blank__header']}>
        Данные об экзаменах отсутствуют...
      </h1>
    </div>
  );
};
